import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footerGap" />
      <div className="footerImage" />
      <p className="footerText">
        <a href="mailto:glearning.feedback@borealisgroup.com">contact</a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.borealisgroup.com/legal/privacy-statement"
        >
          privacy statement Borealis
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://playitsafe.eu/privacypolicy/"
        >
          privacy statement Play it Safe
        </a>
        <span>
          © Borealis - If we can’t do it safely, we don’t do it at all
        </span>
      </p>
    </div>
  );
};

export default Footer;
